export default __webpack_public_path__ + "33849c85e0c3a46dc13e9406bb9ee5f1.svg";